import { endOfDay, startOfDay } from '../utils/time';
import { axiosGetWithCookies, axiosPostWithCookies } from './helper';

export const fetchMessagingList = ({
  from,
  dateTo,
  dateFrom,
  limit = 50,
  includeAcknowledged,
  participantIds,
  recipientId,
  search,
  senderId,
  sort,
  timezone,
  service,
  myMessagesOnly,
}) => {
  let query = `/notification/messages?limit=${limit}`;

  if (dateFrom) {
    const startFrom = startOfDay({
      date: dateFrom,
      timezone: timezone || 'Asia/Dili',
    });
    query += `&fromDate=${startFrom}`;
  }
  if (dateTo) {
    const endAt = endOfDay({
      date: dateTo,
      timeZone: timezone || 'Asia/Dili',
    });
    query += `&toDate=${endAt}`;
  }

  if (service) query += `&service=${service}`;
  if (from) query += `&from=${from}`;
  if (includeAcknowledged)
    query += `&includeAcknowledged=${includeAcknowledged}`;
  if (participantIds) query += `&participantIds=${participantIds}`;
  if (recipientId) query += `&recipientId=${recipientId}`;
  if (search) query += `&search=${search}`;
  if (senderId) query += `&senderId=${senderId}`;
  if (sort) query += `&sort=${sort}`;
  if (myMessagesOnly === false) {
    query += `&myMessagesOnly=${myMessagesOnly}`;
  }
  return axiosGetWithCookies(query);
};

export const sendMessage = message =>
  axiosPostWithCookies(`/notification/messages`, { data: message });

export const acknowledgeMessage = message => {
  return axiosPostWithCookies(`/notification/acknowledge`, { data: message });
};
